import { ResolveFn } from '@angular/router';
import { inject } from '@angular/core';
import { MaintenanceService } from '../services/maintenance-service';
import { catchError, of } from 'rxjs';

export const maintenanceResolver: ResolveFn<any> = (route, state) => {
  const maintenanceService = inject(MaintenanceService);
  const id = route.paramMap.get('id');
  if (!id) {
    return of(null);
  }
  return maintenanceService.getMaintenanceById(id).pipe(
    catchError(() => of(null))
  );
};
